module.exports = __webpack_public_path__ + "assets/img/audi.14d73d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/audi.png
// module id = Zg25
// module chunks = 1